import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { options } from 'corp-front-vue-commons/src/plugins/vuetify'

Vue.use(Vuetify)

export default new Vuetify({
  ...options
})
